"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeProvider = require("../../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var YouTubeIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(YouTubeIcon, _React$Component);

  function YouTubeIcon() {
    _classCallCheck(this, YouTubeIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(YouTubeIcon).apply(this, arguments));
  }

  _createClass(YouTubeIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          fill = _this$props.fill;
      return _react["default"].createElement("div", {
        className: this.props.theme.youTubeIconCircle
      }, _react["default"].createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 21 17"
      }, _react["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: fill
      }, _react["default"].createElement("g", {
        transform: "translate(-409.000000, -226.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(230.000000, 30.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 68.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(5.000000, 31.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 54.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 29.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(162.000000, 0.000000)"
      }, _react["default"].createElement("path", {
        d: "M32.181552,15.287882 C32.943048,16.206224 33.000024,17.613554 33.000024,19.655168 L33.000024,23.345492 C33.000024,25.684952 32.636448,27.036302 31.784328,27.863762 C30.9534,28.670918 29.669016,29.00003 27.351168,29.00003 L17.648784,29.00003 C12.8736,29.00003 12,27.095774 12,23.345492 L12,19.655168 C12,17.719358 12,16.320434 12.736344,15.371006 C13.49148,14.397458 14.914728,14 17.648784,14 L27.351072,14 C30.023928,14 31.423488,14.373356 32.181552,15.287882 Z M25.48212,22.009856 C25.705872,21.890894 25.846128,21.655688 25.845792,21.399368 C25.845432,21.143066 25.704672,20.908004 25.480584,20.789996 L21.074712,18.46814 C20.864856,18.357422 20.61312,18.365828 20.4108,18.490658 C20.208504,18.615164 20.085096,18.838004 20.085096,19.07798 L20.085096,23.737568 C20.085096,23.978012 20.208864,24.20087 20.411496,24.325376 C20.519208,24.391832 20.640744,24.424664 20.762544,24.424664 C20.870088,24.424664 20.9778,24.399122 21.076344,24.346472 L25.48212,22.009856 Z",
        id: "icon_youtube"
      })))))))))));
    }
  }]);

  return YouTubeIcon;
}(_react["default"].Component);

_defineProperty(YouTubeIcon, "propTypes", {
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  fill: _propTypes["default"].string
});

_defineProperty(YouTubeIcon, "defaultProps", {
  width: '21',
  height: '15',
  fill: '#FFF'
});

var _default = (0, _ThemeProvider.applyTheme)('YouTubeIcon', YouTubeIcon);

exports["default"] = _default;